import { queryAllInviteTenants } from '@/api/price/tenantSharing'

export class TenantUtil {
  // 实例集合
  static instance
  constructor() {
    this._map = {}
  }
  get map() {
    return this._map
  }

  set map(value) {
    this._map = value
  }

  static async getInstance() {
    if (!this.instance) {
      this.instance = new TenantUtil()
      await queryAllInviteTenants({ category: '' }).then((res) => {
        this.buildMap(res.data)
      })
    }
    return this.instance
  }
  static buildMap(source) {
    if (!source) return
    source.forEach(obj => {
      this.instance._map[obj.tenantId] = obj
    })
  }
  getTenantNameById(tenantId = 0) {
    if (!this._map || tenantId === 0) {
      return ''
    }
    if (this._map.hasOwnProperty(tenantId)) {
      return this._map[tenantId].name
    }
    return ''
  }
}
